import { cn } from '@/utils/cn'

export function Avatar({ 
  src, 
  alt = '', 
  fallback = '',
  size = 'default',
  className = '',
  ...props 
}) {
  const sizes = {
    sm: 'h-8 w-8 text-xs',
    default: 'h-10 w-10 text-sm',
    lg: 'h-12 w-12 text-base',
    xl: 'h-16 w-16 text-lg',
  }

  const getFallbackInitials = (name) => {
    if (!name) return fallback || '?'
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2)
  }

  return (
    <div
      className={cn(
        'relative flex shrink-0 overflow-hidden rounded-full bg-muted',
        sizes[size],
        className
      )}
      {...props}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          className="aspect-square h-full w-full object-cover"
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center bg-primary text-primary-foreground font-medium">
          {getFallbackInitials(alt || fallback)}
        </div>
      )}
    </div>
  )
}